import { DateMath } from "@linkfluence/models/date";
import { Timezone } from "@linkfluence/models/timezone";

export const Flags = [
  "withRT",
  "favorite",
  "trash",
  "hasStory",
  "verified",
  "withInstagramStory",
  "onlyInstagramStory",
  "withReply",
  "userUpdated",
  "hasChildren",
  "inRelationship",
] as const;

export const RangeTerms = ["followers", "rating"] as const;

export type RangeTerm = typeof RangeTerms[number];

export const DateRangeTerms = [
  "birthDate",
  "created",
  "updated",
  "date",
] as const;

export type DateRangeTerm = typeof DateRangeTerms[number];

export const QueryTerms = ["query", "scoredQuery"] as const;

export type QueryTerm = typeof QueryTerms[number];

export type Range = { gt: string | number; lt: string | number };

export interface TermClause {
  [key: string]: Array<string | number>;
}

export interface DocIdsClause {
  docIds: { in: string[]; not: string[] };
}

export interface WorkspaceClause {
  dashboard: number;
}

export type Flag = typeof Flags[number];

export type FlagClause = Partial<{
  [key in Flag]: boolean;
}>;

export type RangeClause = Partial<{
  [key in RangeTerm]: { gt: number; lt: number };
}>;

export interface AuthorClause {
  author: "other" | "me";
}

export type InfluencersTagsClause = {
  userTags: number[];
};

export type DateRangeClause = Partial<{
  [key in DateRangeTerm]: {
    // Timezone added by backend in Clause
    tz?: Timezone;
    // match documents after this date
    after?: string | DateMath;
    // match documents before this date
    before?: string | DateMath;
    // same as before
    lt?: string | DateMath;
    // same as after
    gt?: string | DateMath;
    // same as before
    to?: string | DateMath;
    // same as after
    from?: string | DateMath;
  };
}>;

export type QueryClause = Partial<{
  [key in QueryTerm]: string;
}>;

export interface CustomFieldsClause {
  customFields: TermClause;
}

type ClauseWithoutNot =
  | FlagClause
  | CustomFieldsClause
  | QueryClause
  | TermClause
  | RangeClause
  | DateRangeClause
  | WorkspaceClause
  | AuthorClause
  | DocIdsClause
  | Clause;

export interface NotClause {
  not: ClauseWithoutNot;
}

export interface NotTermClause {
  not: TermClause;
}

export type InnerClause = NotClause | ClauseWithoutNot;

export interface Clause {
  and: InnerClause[];
}
